__webpack_require__.p = "https://takestock360.demomywebapp.com/";